import {indexBy} from 'ramda';

import {useGetBranchListQuery} from '@dms/api/core';
import {BranchListItemResponseBody} from '@dms/api/shared';

import {getSafely} from 'shared/web';

export const useBranches = () => {
  const {data: branchList, ...args} = useGetBranchListQuery();
  const branchesById = indexBy((branch) => branch.id, branchList?.branchListItems ?? []);

  const getBranchById = (branchId: string) => getSafely(branchesById, branchId);

  return {
    ...args,
    getBranchById,
    data: branchList,
    branchOptions: branchList?.branchListItems?.map(branchToOption) ?? [],
  };
};

const branchToOption = (branch: BranchListItemResponseBody) => ({
  value: branch.id,
  label: branch.marketingName,
});
